module.exports = __webpack_public_path__ + "static/media/school_area.939e97d0.svg";